/**
 * @type {Array<Object>}
 */
// based on https://github.com/haliaeetus/iso-639/blob/master/data/iso_639-1.json
const LANGUAGES = [
    {
        langIso: 'aa',
        name: 'Afar',
    },
    {
        langIso: 'ab',
        name: 'Abkhaz',
    },
    {
        langIso: 'ae',
        name: 'Avestan',
    },
    {
        langIso: 'af',
        name: 'Afrikaans',
    },
    {
        langIso: 'ak',
        name: 'Akan',
    },
    {
        langIso: 'am',
        name: 'Amharic',
    },
    {
        langIso: 'an',
        name: 'Aragonese',
    },
    {
        langIso: 'ar',
        name: 'Arabic',
    },
    {
        langIso: 'as',
        name: 'Assamese',
    },
    {
        langIso: 'av',
        name: 'Avaric',
    },
    {
        langIso: 'ay',
        name: 'Aymara',
    },
    {
        langIso: 'az',
        name: 'Azerbaijani',
    },
    {
        langIso: 'ba',
        name: 'Bashkir',
    },
    {
        langIso: 'be',
        name: 'Belarusian',
    },
    {
        langIso: 'bg',
        name: 'Bulgarian',
    },
    {
        langIso: 'bh',
        name: 'Bihari',
    },
    {
        langIso: 'bi',
        name: 'Bislama',
    },
    {
        langIso: 'bm',
        name: 'Bambara',
    },
    {
        langIso: 'bn',
        name: 'Bengali, Bangla',
    },
    {
        langIso: 'bo',
        name: 'Tibetan Standard, Tibetan, Central',
    },
    {
        langIso: 'br',
        name: 'Breton',
    },
    {
        langIso: 'bs',
        name: 'Bosnian',
    },
    {
        langIso: 'ca',
        name: 'Catalan',
    },
    {
        langIso: 'ce',
        name: 'Chechen',
    },
    {
        langIso: 'ch',
        name: 'Chamorro',
    },
    {
        langIso: 'co',
        name: 'Corsican',
    },
    {
        langIso: 'cr',
        name: 'Cree',
    },
    {
        langIso: 'cs',
        name: 'Czech',
    },
    {
        langIso: 'cu',
        name: 'Old Church Slavonic, Church Slavonic, Old Bulgarian',
    },
    {
        langIso: 'cv',
        name: 'Chuvash',
    },
    {
        langIso: 'cy',
        name: 'Welsh',
    },
    {
        langIso: 'da',
        name: 'Danish',
    },
    {
        langIso: 'de',
        name: 'German',
    },
    {
        langIso: 'dv',
        name: 'Divehi, Dhivehi, Maldivian',
    },
    {
        langIso: 'dz',
        name: 'Dzongkha',
    },
    {
        langIso: 'ee',
        name: 'Ewe',
    },
    {
        langIso: 'el',
        name: 'Greek (modern)',
    },
    {
        langIso: 'en',
        name: 'English',
    },
    {
        langIso: 'eo',
        name: 'Esperanto',
    },
    {
        langIso: 'es',
        name: 'Spanish',
    },
    {
        langIso: 'et',
        name: 'Estonian',
    },
    {
        langIso: 'eu',
        name: 'Basque',
    },
    {
        langIso: 'fa',
        name: 'Persian (Farsi)',
    },
    {
        langIso: 'ff',
        name: 'Fula, Fulah, Pulaar, Pular',
    },
    {
        langIso: 'fi',
        name: 'Finnish',
    },
    {
        langIso: 'fj',
        name: 'Fijian',
    },
    {
        langIso: 'fo',
        name: 'Faroese',
    },
    {
        langIso: 'fr',
        name: 'French',
    },
    {
        langIso: 'fy',
        name: 'Western Frisian',
    },
    {
        langIso: 'ga',
        name: 'Irish',
    },
    {
        langIso: 'gd',
        name: 'Scottish Gaelic, Gaelic',
    },
    {
        langIso: 'gl',
        name: 'Galician',
    },
    {
        langIso: 'gn',
        name: 'Guaraní',
    },
    {
        langIso: 'gu',
        name: 'Gujarati',
    },
    {
        langIso: 'gv',
        name: 'Manx',
    },
    {
        langIso: 'ha',
        name: 'Hausa',
    },
    {
        langIso: 'he',
        name: 'Hebrew (modern)',
    },
    {
        langIso: 'hi',
        name: 'Hindi',
    },
    {
        langIso: 'ho',
        name: 'Hiri Motu',
    },
    {
        langIso: 'hr',
        name: 'Croatian',
    },
    {
        langIso: 'ht',
        name: 'Haitian, Haitian Creole',
    },
    {
        langIso: 'hu',
        name: 'Hungarian',
    },
    {
        langIso: 'hy',
        name: 'Armenian',
    },
    {
        langIso: 'hz',
        name: 'Herero',
    },
    {
        langIso: 'ia',
        name: 'Interlingua',
    },
    {
        langIso: 'id',
        name: 'Indonesian',
    },
    {
        langIso: 'ie',
        name: 'Interlingue',
    },
    {
        langIso: 'ig',
        name: 'Igbo',
    },
    {
        langIso: 'ii',
        name: 'Nuosu',
    },
    {
        langIso: 'ik',
        name: 'Inupiaq',
    },
    {
        langIso: 'io',
        name: 'Ido',
    },
    {
        langIso: 'is',
        name: 'Icelandic',
    },
    {
        langIso: 'it',
        name: 'Italian',
    },
    {
        langIso: 'iu',
        name: 'Inuktitut',
    },
    {
        langIso: 'ja',
        name: 'Japanese',
    },
    {
        langIso: 'jv',
        name: 'Javanese',
    },
    {
        langIso: 'ka',
        name: 'Georgian',
    },
    {
        langIso: 'kg',
        name: 'Kongo',
    },
    {
        langIso: 'ki',
        name: 'Kikuyu, Gikuyu',
    },
    {
        langIso: 'kj',
        name: 'Kwanyama, Kuanyama',
    },
    {
        langIso: 'kk',
        name: 'Kazakh',
    },
    {
        langIso: 'kl',
        name: 'Kalaallisut, Greenlandic',
    },
    {
        langIso: 'km',
        name: 'Khmer',
    },
    {
        langIso: 'kn',
        name: 'Kannada',
    },
    {
        langIso: 'ko',
        name: 'Korean',
    },
    {
        langIso: 'kr',
        name: 'Kanuri',
    },
    {
        langIso: 'ks',
        name: 'Kashmiri',
    },
    {
        langIso: 'ku',
        name: 'Kurdish',
    },
    {
        langIso: 'kv',
        name: 'Komi',
    },
    {
        langIso: 'kw',
        name: 'Cornish',
    },
    {
        langIso: 'ky',
        name: 'Kyrgyz',
    },
    {
        langIso: 'la',
        name: 'Latin',
    },
    {
        langIso: 'lb',
        name: 'Luxembourgish, Letzeburgesch',
    },
    {
        langIso: 'lg',
        name: 'Ganda',
    },
    {
        langIso: 'li',
        name: 'Limburgish, Limburgan, Limburger',
    },
    {
        langIso: 'ln',
        name: 'Lingala',
    },
    {
        langIso: 'lo',
        name: 'Lao',
    },
    {
        langIso: 'lt',
        name: 'Lithuanian',
    },
    {
        langIso: 'lu',
        name: 'Luba-Katanga',
    },
    {
        langIso: 'lv',
        name: 'Latvian',
    },
    {
        langIso: 'mg',
        name: 'Malagasy',
    },
    {
        langIso: 'mh',
        name: 'Marshallese',
    },
    {
        langIso: 'mi',
        name: 'Māori',
    },
    {
        langIso: 'mk',
        name: 'Macedonian',
    },
    {
        langIso: 'ml',
        name: 'Malayalam',
    },
    {
        langIso: 'mn',
        name: 'Mongolian',
    },
    {
        langIso: 'mr',
        name: 'Marathi (Marāṭhī)',
    },
    {
        langIso: 'ms',
        name: 'Malay',
    },
    {
        langIso: 'mt',
        name: 'Maltese',
    },
    {
        langIso: 'my',
        name: 'Burmese',
    },
    {
        langIso: 'na',
        name: 'Nauruan',
    },
    {
        langIso: 'nb',
        name: 'Norwegian Bokmål',
    },
    {
        langIso: 'nd',
        name: 'Northern Ndebele',
    },
    {
        langIso: 'ne',
        name: 'Nepali',
    },
    {
        langIso: 'ng',
        name: 'Ndonga',
    },
    {
        langIso: 'nl',
        name: 'Dutch',
    },
    {
        langIso: 'nn',
        name: 'Norwegian Nynorsk',
    },
    {
        langIso: 'no',
        name: 'Norwegian',
    },
    {
        langIso: 'nr',
        name: 'Southern Ndebele',
    },
    {
        langIso: 'nv',
        name: 'Navajo, Navaho',
    },
    {
        langIso: 'ny',
        name: 'Chichewa, Chewa, Nyanja',
    },
    {
        langIso: 'oc',
        name: 'Occitan',
    },
    {
        langIso: 'oj',
        name: 'Ojibwe, Ojibwa',
    },
    {
        langIso: 'om',
        name: 'Oromo',
    },
    {
        langIso: 'or',
        name: 'Oriya',
    },
    {
        langIso: 'os',
        name: 'Ossetian, Ossetic',
    },
    {
        langIso: 'pa',
        name: '(Eastern) Punjabi',
    },
    {
        langIso: 'pi',
        name: 'Pāli',
    },
    {
        langIso: 'pl',
        name: 'Polish',
    },
    {
        langIso: 'ps',
        name: 'Pashto, Pushto',
    },
    {
        langIso: 'pt',
        name: 'Portuguese',
    },
    {
        langIso: 'qu',
        name: 'Quechua',
    },
    {
        langIso: 'rm',
        name: 'Romansh',
    },
    {
        langIso: 'rn',
        name: 'Kirundi',
    },
    {
        langIso: 'ro',
        name: 'Romanian',
    },
    {
        langIso: 'ru',
        name: 'Russian',
    },
    {
        langIso: 'rw',
        name: 'Kinyarwanda',
    },
    {
        langIso: 'sa',
        name: 'Sanskrit (Saṁskṛta)',
    },
    {
        langIso: 'sc',
        name: 'Sardinian',
    },
    {
        langIso: 'sd',
        name: 'Sindhi',
    },
    {
        langIso: 'se',
        name: 'Northern Sami',
    },
    {
        langIso: 'sg',
        name: 'Sango',
    },
    {
        langIso: 'si',
        name: 'Sinhalese, Sinhala',
    },
    {
        langIso: 'sk',
        name: 'Slovak',
    },
    {
        langIso: 'sl',
        name: 'Slovene',
    },
    {
        langIso: 'sm',
        name: 'Samoan',
    },
    {
        langIso: 'sn',
        name: 'Shona',
    },
    {
        langIso: 'so',
        name: 'Somali',
    },
    {
        langIso: 'sq',
        name: 'Albanian',
    },
    {
        langIso: 'sr',
        name: 'Serbian',
    },
    {
        langIso: 'ss',
        name: 'Swati',
    },
    {
        langIso: 'st',
        name: 'Southern Sotho',
    },
    {
        langIso: 'su',
        name: 'Sundanese',
    },
    {
        langIso: 'sv',
        name: 'Swedish',
    },
    {
        langIso: 'sw',
        name: 'Swahili',
    },
    {
        langIso: 'ta',
        name: 'Tamil',
    },
    {
        langIso: 'te',
        name: 'Telugu',
    },
    {
        langIso: 'tg',
        name: 'Tajik',
    },
    {
        langIso: 'th',
        name: 'Thai',
    },
    {
        langIso: 'ti',
        name: 'Tigrinya',
    },
    {
        langIso: 'tk',
        name: 'Turkmen',
    },
    {
        langIso: 'tl',
        name: 'Tagalog',
    },
    {
        langIso: 'tn',
        name: 'Tswana',
    },
    {
        langIso: 'to',
        name: 'Tonga (Tonga Islands)',
    },
    {
        langIso: 'tr',
        name: 'Turkish',
    },
    {
        langIso: 'ts',
        name: 'Tsonga',
    },
    {
        langIso: 'tt',
        name: 'Tatar',
    },
    {
        langIso: 'tw',
        name: 'Twi',
    },
    {
        langIso: 'ty',
        name: 'Tahitian',
    },
    {
        langIso: 'ug',
        name: 'Uyghur',
    },
    {
        langIso: 'uk',
        name: 'Ukrainian',
    },
    {
        langIso: 'ur',
        name: 'Urdu',
    },
    {
        langIso: 'uz',
        name: 'Uzbek',
    },
    {
        langIso: 've',
        name: 'Venda',
    },
    {
        langIso: 'vi',
        name: 'Vietnamese',
    },
    {
        langIso: 'vo',
        name: 'Volapük',
    },
    {
        langIso: 'wa',
        name: 'Walloon',
    },
    {
        langIso: 'wo',
        name: 'Wolof',
    },
    {
        langIso: 'xh',
        name: 'Xhosa',
    },
    {
        langIso: 'yi',
        name: 'Yiddish',
    },
    {
        langIso: 'yo',
        name: 'Yoruba',
    },
    {
        langIso: 'za',
        name: 'Zhuang, Chuang',
    },
    {
        langIso: 'zh',
        name: 'Chinese',
    },
    {
        langIso: 'zu',
        name: 'Zulu',
    },
];

export default LANGUAGES;
